import axios from 'axios';
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  headers: {
    'Content-Type': 'application/json',
    "ngrok-skip-browser-warning": "true"
  },
});

let memoryTokenGetter = null;

export const injectTokenGetter = (getterFn) => {
  memoryTokenGetter = getterFn;
};

API.interceptors.request.use(
  (config) => {
    if (memoryTokenGetter) {
      const token = memoryTokenGetter();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default API;